module.exports = "/_next/static/images/paul-gilbert@3x-77d4cfa36203338f46b1682b09ad03a7.png";